import { render, staticRenderFns } from "./similar.vue?vue&type=template&id=37029915&scoped=true"
import script from "./similar.vue?vue&type=script&lang=js"
export * from "./similar.vue?vue&type=script&lang=js"
import style0 from "./similar.vue?vue&type=style&index=0&id=37029915&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37029915",
  null
  
)

export default component.exports